import { render, staticRenderFns } from "./ConsultantBillingAccounts.vue?vue&type=template&id=5a0cde66&scoped=true&"
import script from "./ConsultantBillingAccounts.vue?vue&type=script&lang=ts&"
export * from "./ConsultantBillingAccounts.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultantBillingAccounts.vue?vue&type=style&index=0&id=5a0cde66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0cde66",
  null
  
)

export default component.exports